class ScriptLoader {
  constructor() {
    this._scripts = new Map();
  }

  load(src) {
    if (this._scripts.has(src)) {
      return this._scripts.get(src);
    }

    const script = new Promise((resolve, reject) => {
      const tag = document.createElement('script');

      tag.src = src;
      tag.onload = resolve;
      tag.onerror = reject;

      document.body.appendChild(tag);
    });

    this._scripts.set(src, script);

    return script;
  }
}

export default new ScriptLoader();
